import { render, staticRenderFns } from "./CreateFromRealworks.vue?vue&type=template&id=af950f56&"
import script from "./CreateFromRealworks.vue?vue&type=script&lang=ts&"
export * from "./CreateFromRealworks.vue?vue&type=script&lang=ts&"
import style0 from "./CreateFromRealworks.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports